import { FC, useMemo } from 'react'
import { FutureLayerUID, FutureLayer } from 'components/features/future/types'
import { FuturePanePreset } from 'components/features/future/FuturePanePreset/FuturePanePreset'
import * as yup from 'yup'
import { useLayerSelector, extendCommonSchema } from 'components/features/future/helpers'
import { FutureWhenInput } from 'components/features/future/FutureWhenInput/FutureWhenInput'
import { FutureFieldSlider } from 'components/features/future/FutureField/FutureFieldSlider'
import { maskCurrencyPositive } from 'components/atoms/inputs/maskedInput'
import { schemaNumber } from 'schemas/baseSchema'
import { useCollectLayerErrors } from 'components/features/future/hooks/useCollectErrors'
import { ObjectSchema } from 'yup'
import { LayerStatus } from 'components/features/future/LayerStatus/LayerStatus'

const LAYER_SLUG = 'inherit_money' as const
type LayerSlugType = typeof LAYER_SLUG
type LayerType = Extract<FutureLayer, { slug: LayerSlugType }>

const schemaCreator = extendCommonSchema<LayerSlugType>(yup.object({
  value: schemaNumber,
}) as ObjectSchema<LayerType>)

type FutureLayerPaneInheritMoneyProps = {
  uid?: FutureLayerUID
  onCancel: () => void
}

export const FutureLayerPaneInheritMoney: FC<FutureLayerPaneInheritMoneyProps> = (props) => {
  const { onCancel, uid } = props
  const layer = useLayerSelector<LayerSlugType>(props)

  return (
    <FuturePanePreset<LayerSlugType>
      layer={ layer }
      slug={ LAYER_SLUG }
      name='Inherit Money'
      icon='inheritance'
      type='event'
      schemaCreator={ schemaCreator }
      onCancel={ onCancel }
    >
      <FormFields uid={ uid } />
    </FuturePanePreset>
  )
}

type FormFieldsProps = {
  uid?: FutureLayerUID
}
const FormFields: FC<FormFieldsProps> = (props) => {
  const { uid } = props

  const errors = useCollectLayerErrors<LayerType>()

  const completeChild = useMemo(() => (
    <>
      <h1>
        Event Completed
      </h1>
      Remember to link all your accounts to accurately track your Net Worth.
    </>
  ), [])

  return (
    <LayerStatus uid={ uid || null } completeContent={ completeChild } skipPartialState type='event'>
      <FutureWhenInput error={ errors.whenField } />

      <FutureFieldSlider
        label='Amount'
        name='value'
        mask={ maskCurrencyPositive }

        error={ errors.value }

        min={ 1 }
        max={ 5001000 }
        step={ 10000 }
      />
    </LayerStatus>
  )
}
